const description = "Clears all current validation errors in the form.";

const execute = ({ validation }) => {
    validation.clearErrors();

    return '';
};

const ClearErrors = {
    description,
    execute,
};

export default ClearErrors;

